const FromArrHP = [
    {
      title: "客户编号：",
      inputtype: "input",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 190,
      height: 32,
      disabled: false,
      marginLeft: 25,
      marginTop: 5,
      displayVal: "inline-block",
      fontWeightVal: 500
    },
    {
      title: "客户名称：",
      inputtype: "input",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 190,
      height: 32,
      disabled: false,
      marginLeft: 45,
      marginTop: 5,
      displayVal: "inline-block",
      fontWeightVal: 500
    },
    {
      title: "授权状态：",
      inputtype: "select",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "",
      placeholder: "请选择",
      width: 190,
      height: 32,
      disabled: false,
      marginLeft: 45,
      marginTop: 5,
      displayVal: "inline-block",
      fontWeightVal: 500,
      options: [
        {
            value: '全部',
            key: ''
          }, {
            value: '正式',
            key: '1'
          }, {
            value: '临时',
            key: '0'
          },
      ]
    },
    {
        modelvalue: "经销商",
        title: "客服分类：",
        inputtype: "select",
        inputflag: true,
        fontSize: 14,
        color: "#333333",
        lableheight: 20,
        X: false,
        types: "",
        placeholder: "请选择",
        width: 200,
        height: 32,
        disabled: true,
        marginLeft: 25,
        marginTop: 5,
        displayVal: "inline-block",
        fontWeightVal: 500,
        options: []
      },
    {
      title: "创建日期：",
      StartTime: '',
      EndTime: '',
      inputtype: "dateSection",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "date",
      placeholder: "发布时间",
      widthLeft: 200,
      widthRight: 280,
      disabled: false,
      marginLeft: 50,
      marginTop: 5,
      displayVal: "inline-block",
      fontWeightVal: 500
    },
  ];
  export default FromArrHP;
  